import { render } from "./PopupTab.vue?vue&type=template&id=273243bd"
import script from "./PopupTab.vue?vue&type=script&lang=js"
export * from "./PopupTab.vue?vue&type=script&lang=js"

import "./PopupTab.vue?vue&type=style&index=0&id=273243bd&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__